import { render, staticRenderFns } from "./AddVendor.vue?vue&type=template&id=1418d54f&scoped=true"
import script from "./AddVendor.vue?vue&type=script&lang=js"
export * from "./AddVendor.vue?vue&type=script&lang=js"
import style0 from "./AddVendor.vue?vue&type=style&index=0&id=1418d54f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1418d54f",
  null
  
)

export default component.exports